function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Box, Flex, Tag, TagLabel, TagCloseButton, Text, Link, Tooltip } from '@tapresearch/ui/components';
import React, { useCallback, useContext, useMemo } from 'react';
import { filterContext } from '../FilterProvider';
export function FilterBadges(_param) {
    var _param_omitFilters = _param.omitFilters, omitFilters = _param_omitFilters === void 0 ? [] : _param_omitFilters, _param_filterNames = _param.filterNames, filterNames = _param_filterNames === void 0 ? {} : _param_filterNames, _param_onTagClicked = _param.onTagClicked, onTagClicked = _param_onTagClicked === void 0 ? function() {
    //
    } : _param_onTagClicked, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, rest = _object_without_properties(_param, [
        "omitFilters",
        "filterNames",
        "onTagClicked",
        "isDisabled"
    ]);
    var _useContext = useContext(filterContext), filterLabels = _useContext.filterLabels, filterValues = _useContext.filterValues, onFilterItemChange = _useContext.onFilterItemChange, onClearFilters = _useContext.onClearFilters;
    var omitFiltersSet = useMemo(function() {
        return new Set(omitFilters);
    }, [
        omitFilters
    ]);
    var _useMemo = _sliced_to_array(useMemo(function() {
        var filterKeys = [];
        var innerFormattedFilterLabels = Object.keys(filterLabels).filter(function(key) {
            return !omitFiltersSet.has(key);
        }).map(function(key) {
            filterKeys.push(key);
            var label = filterLabels[key];
            var filterName = filterNames[key] || key;
            var valueOrLabel = Array.isArray(label) && label.length > 0 && label || !Array.isArray(label) && label || filterValues[key];
            var valueLabel = Array.isArray(valueOrLabel) ? valueOrLabel.join(',') : valueOrLabel;
            return [
                key,
                filterName,
                valueLabel
            ];
        });
        return [
            innerFormattedFilterLabels,
            filterKeys
        ];
    }, [
        filterLabels,
        filterValues,
        filterNames,
        omitFiltersSet
    ]), 2), formattedFilterLabels = _useMemo[0], filterKeys = _useMemo[1];
    var onTagRemoveClick = useCallback(function(filterKey) {
        onFilterItemChange(filterKey, undefined, undefined);
    }, [
        onFilterItemChange
    ]);
    var innerOnTackClick = useCallback(function(e) {
        e.preventDefault();
        onTagClicked();
    }, [
        onTagClicked
    ]);
    var innerOnClearFilters = useCallback(function() {
        onClearFilters(filterKeys);
    }, [
        filterKeys,
        onClearFilters
    ]);
    if (formattedFilterLabels === undefined || formattedFilterLabels.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Box, _object_spread_props(_object_spread({}, rest), {
        "data-testid": "filter-badges-wrapper".concat(isDisabled ? '-disabled' : '')
    }), /*#__PURE__*/ React.createElement(Flex, {
        fontSize: "sm",
        alignItems: "center",
        mb: "2.5"
    }, /*#__PURE__*/ React.createElement(Text, {
        "data-testid": "filter-badges-count",
        color: "gray.500"
    }, "Filter: ", formattedFilterLabels.length), /*#__PURE__*/ React.createElement(Text, {
        ml: "3"
    }, "|"), /*#__PURE__*/ React.createElement(Link, {
        ml: "5",
        fontSize: "xs",
        fontWeight: "bold",
        color: "blue.600",
        _hover: {
            color: 'blue.700',
            textDecoration: 'underline'
        },
        "data-testid": "filter-badges-clear-button",
        onClick: function(e) {
            e.preventDefault();
            innerOnClearFilters();
        }
    }, "Clear all")), /*#__PURE__*/ React.createElement(Flex, {
        rowGap: "8px",
        columnGap: "8px",
        mb: "2.5"
    }, formattedFilterLabels.map(function(param) {
        var _$_param = _sliced_to_array(param, 3), filterKey = _$_param[0], filterName = _$_param[1], valueLabel = _$_param[2];
        return /*#__PURE__*/ React.createElement(Tooltip, {
            key: "".concat(filterName, "-tag"),
            label: valueLabel,
            hasArrow: true,
            placement: "top"
        }, /*#__PURE__*/ React.createElement(Tag, _object_spread_props(_object_spread({}, TagStyle), {
            colorScheme: isDisabled ? 'gray' : 'blue',
            color: isDisabled ? 'gray.500' : 'blue.500',
            bg: isDisabled ? 'gray.100' : 'blue.100',
            "data-testid": "filter-badge-".concat(filterKey),
            onClick: innerOnTackClick
        }), /*#__PURE__*/ React.createElement(TagLabel, TagLabelStyle, /*#__PURE__*/ React.createElement(Text, {
            fontSize: "sm",
            mr: "1",
            as: "span",
            textTransform: "capitalize"
        }, filterName, ":"), /*#__PURE__*/ React.createElement(Text, {
            textOverflow: "ellipsis",
            overflow: "hidden",
            fontSize: "sm",
            color: isDisabled ? 'gray.500' : 'black'
        }, valueLabel)), /*#__PURE__*/ React.createElement(TagCloseButton, {
            "data-testid": "filter-badges-remove-".concat(filterKey, "-filter-button"),
            onClick: function(e) {
                e.stopPropagation();
                onTagRemoveClick(filterKey);
            }
        })));
    })));
}
var TagStyle = {
    maxWidth: '250px',
    cursor: 'pointer',
    py: 1,
    px: 2,
    pr: 3,
    size: 'md',
    alignItems: 'center',
    colorScheme: 'blue',
    bg: 'blue.100',
    borderRadius: 'md',
    boxShadow: 'none',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    color: 'blue.500',
    fontWeight: 'bold',
    _hover: {
        bg: 'blue.200',
        color: 'blue.600'
    }
};
var TagLabelStyle = {
    display: 'flex',
    flexGrow: 1,
    px: 2,
    alignItems: 'center'
};
